export function isMultiClient(clientCode: string | undefined): boolean {
    if (clientCode === undefined) {
        return false;
    }

    const multiClientCodes = ['MLTI', 'TMTL', 'UT58UAT', 'MT14UAT'];
    return multiClientCodes.some((code) => clientCode.includes(code));
}
